export default () => ({
    isOpen: false,
    open() {
        this.isOpen = true;
    },
    close() {
        this.isOpen = false;
    },
    dropdown: {
        ["@mouseover"](e) {
            if (e.target.hasAttribute("x-bind")) {
                this.close();
            } else {
                this.open();
            }
        },
        ["@mouseout"]() {
            this.close();
        },
        ["x-bind:class"]() {
            return {
                "z-10": this.isOpen,
            };
        },
    },
    body: {
        ["x-init"]() {
            this.$el.classList.remove("hidden");
        },
        ["x-bind:class"]() {
            return { "border-b-[3px] z-20 border-orange": this.isOpen };
        },
        ["x-bind:style"]() {
            return {
                height: this.isOpen ? this.$el.scrollHeight + "px" : "0px",
            };
        },
    },
});
